module.exports = __webpack_public_path__ + "media/assets/site_images/vegetables-3f389758b3fb3e1e9a11745c1dc14678.jpg";